import { opensInPlace, type Click } from "./page-chrome.ts"

/*
 * What the Ticket peek decides without a browser: which clicks on a ticket open it.
 */

/**
 * Whether a click on a ticket opens it in the peek: a plain primary click does, on the desk layout.
 * A modifier or a middle click falls through to the link, so the browser opens the full page as it
 * would, and a click something else already took (a drag's last) is left alone. On the `compact`
 * layout no click does: the peek is the desk's, and a tap follows the link to the ticket's page.
 */
export function opensPeek(click: Click, compact: boolean) {
  return !compact && opensInPlace(click)
}
